
(function () {

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.search.indexOf("contact_posted=true") > -1) {
    setTimeout(function () {
      const success = document.querySelector(".form-status");

      if (success) {
        const top =
          success.getBoundingClientRect().top +
          window.pageYOffset -
          200;

        window.scrollTo({
          top: top,
          behavior: "smooth",
        });
      }
    }, 1000);
  }
});

  // Save scroll position while scrolling
  if (window.location.pathname === "/") {
    window.addEventListener("scroll", function () {
      sessionStorage.setItem("homeScroll", window.scrollY);
    });
  }

  // Restore scroll position when returning to homepage
  window.addEventListener("pageshow", function (event) {

    if (window.location.pathname !== "/") return;

    const scroll = sessionStorage.getItem("homeScroll");

    if (scroll) {
      setTimeout(function () {
        window.scrollTo({
          top: parseInt(scroll),
          behavior: "instant"
        });
      }, 100);
    }

  });

})();

$(document).ready(function () {
  $(".banners_list").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  $(".review-list").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });
  //  $(".extra-product-slider").slick({
  //         infinite: false,
  //         slidesToShow: 4,
  //         slidesToScroll: 1,
  //         arrows: true,
  //         dots: false,
  //         responsive: [
  //           {
  //             breakpoint: 1440,
  //             settings: {
  //               slidesToScroll: 1,
  //               slidesToShow: 4
  //             }
  //           },
  //           {
  //             breakpoint: 1024,
  //             settings: {
  //               slidesToScroll: 1,
  //               slidesToShow: 3
  //             }
  //           },
  //           {
  //             breakpoint: 640,
  //             settings: {
  //               slidesToScroll: 1,
  //               slidesToShow: 2
  //             }
  //           }
  //         ]
        // });
  
  $('.marquee-left').marquee({
        direction: 'left',
        duration: 60000,
        delayBeforeStart: 0,
        duplicated: true,
        gap: 0,
        startVisible: true
    });

});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});

document.addEventListener('click', function (event) {
  const btn = event.target.closest('.menu-close-icon');
  if (!btn) return;

  const openSummary = document.querySelector('menu-drawer details[open] > summary');
  if (openSummary) {
    openSummary.click();
  }
});

// sticky fiter

(function () {
  const STICKY_BODY_CLASS = 'facets-sticky';
  const STICKY_DIV_CLASS  = 'is-sticky';

  const facetsContainer = document.querySelector(
    '.facets-container, .facets-container-drawer, #main-collection-filters'
  );

  if (!facetsContainer) return;

  let lastScrollY = window.scrollY;

  // IntersectionObserver — watches when facets div enters/leaves viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Div is visible in screen → remove both classes
        document.body.classList.remove(STICKY_BODY_CLASS);
        facetsContainer.classList.remove(STICKY_DIV_CLASS);
      }
    });
  }, {
    threshold: 0.1 // triggers when at least 10% of div is visible
  });

  observer.observe(facetsContainer);

  // Scroll — only adds classes when scrolling down
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      // Scrolling DOWN → facets off screen → add classes
      document.body.classList.add(STICKY_BODY_CLASS);
      facetsContainer.classList.add(STICKY_DIV_CLASS);
    }

    lastScrollY = currentScrollY;
  }, { passive: true });
})();

document.querySelector('.mobile-filter__close')?.addEventListener('click', () => {
  document.querySelector('.mobile-facets__wrapper summary')?.click();
});